import { cn } from '@/lib/utils/utils';
import { type LucideIcon } from 'lucide-react';

export function InsightCardIcon({
  icon: Icon,
  className,
}: {
  icon: LucideIcon;
  className?: string;
}) {
  return (
    <span
      className={cn(
        'flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-primary-50 text-primary-700',
        className
      )}
    >
      <Icon className="h-4 w-4" />
    </span>
  );
}
